import { model as sessionModel } from '$/session'
import { createEvent, sample, type EventCallable } from 'effector'
import { loadBanners, resetBanners } from './banners'
import { dynamicModuleModel } from '~/widgets/DynamicModule'
import { STATIC_IDENTIFIERS } from '~/features/appearance/lib'
import { nay } from '~/shared/helpers'
import { getHomeRowsFx } from './request'
import { appearanceFeature } from '~/features/appearance'

export * from './request'
export * from './old-home-model'

const internalInit = createEvent<{
  identifier: string
  query: URLSearchParams
}>()

export const init: EventCallable<{ query: URLSearchParams }> =
  internalInit.prepend(({ query }) => ({
    identifier: STATIC_IDENTIFIERS.HOME,
    query,
  }))
export const left = createEvent()

sample({
  clock: internalInit,
  fn: (params) => params.identifier,
  target: appearanceFeature.setIdentifier,
})

//
// banners
//

sample({
  clock: init,
  target: loadBanners,
})

sample({
  clock: sessionModel.$session,
  target: resetBanners,
})

//
// rows
//

sample({
  clock: internalInit,
  target: dynamicModuleModel.initModule,
})

sample({
  clock: left,
  source: appearanceFeature.$currentIdentifier,
  fn: (identifier) => (identifier ? { identifier } : { identifier: '' }),
  target: dynamicModuleModel.leaveModule,
})

sample({
  clock: sessionModel.$session,
  target: dynamicModuleModel.resetRows,
})

//
// fx
//

// use custom fx for home page
sample({
  clock: init,
  source: dynamicModuleModel.$customFx,
  filter: (customFx) => nay(customFx?.[STATIC_IDENTIFIERS.HOME]),
  fn: (customFx) => ({
    ...customFx,
    [STATIC_IDENTIFIERS.HOME]: getHomeRowsFx,
  }),
  target: dynamicModuleModel.$customFx,
})
